import DispatchConstants from '../../constants/DispatchConstants';

type Payload = {
  displayPostActivationModal?: boolean;
  daysExtended?: number | null;
};

const initState = {
  displayPostActivationModal: false,
  daysExtended: null,
};

const postActivationState = (state = initState, action: { type?: string; payload?: Payload }) => {
  const { type, payload } = action;

  switch (type) {
    case DispatchConstants.UPDATE_POST_ACTIVATION_STATE: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
};

export default postActivationState;
